import { Controller } from 'stimulus';

// Shows a full-screen loading overlay when a slow, full-page tab link is
// clicked (Turbo Drive is disabled, so these are full navigations with no
// built-in progress indicator). The overlay is wiped automatically when the
// next page renders.
export default class extends Controller {
  show(event) {
    const link = event.target.closest('a');
    if (!link || this._overlay) return;

    const overlay = document.createElement('div');
    overlay.className = 'admin-tab-loading';
    overlay.innerHTML =
      '<button class="button is-loading is-large is-white admin-tab-loading__spinner" tabindex="-1">Loading</button>';
    document.body.appendChild(overlay);
    this._overlay = overlay;
  }
}
